export default {
	decimalPrecision: 3,
	showTimeInTooltip: false,
	useOrdinal: true,
	labelNoData: 'No data for this time frame',
	labelDataError: 'Something went wrong while fetching the data',
	liveTickUpdates: false,
};
